import { Fluid } from "../types/BaseTypes";

export default [
  {
    enabled: true,
    id: "XL10",
    title: "Opteon™ XL10",
    lfl: 0.289,
    m1x1_5: 1.734,
    m2a: 7.514,
    m3b: 37.57,
    qlmv: 0.06,
    qlav: 0.14,
    formula: "(R1234yf, GWP¹ = 1)",
    description:
      "A mildly flammable (A2L) hydrofluoro-olefin (HFO) based refrigerant with global warming potential (GWP¹) lower than CO2 (<1), offering the optimal balance of properties to replace R-134a in new equipment designs including commercial, industrial and human comfort applications.",
  },
  {
    enabled: true,
    id: "XL20",
    title: "Opteon™ XL20",
    lfl: 0.293,
    m1x1_5: 1.758,
    m2a: 7.618,
    m3b: 38.09,
    qlmv: 0.061,
    qlav: 0.14,
    formula: "(R454C, GWP¹ = 146)",
    description:
      "A mildly flammable (A2L) hydrofluoro-olefin (HFO) energy efficient² refrigerant with global warming potential (GWP¹) less than 150, offering the optimal balance of properties to replace R-404A in positive displacement, direct expansion low- and medium temperature commercial, industrial and heat pump applications.",
  },
  {
    enabled: true,
    id: "XL40",
    title: "Opteon™ XL40",
    lfl: 0.278,
    m1x1_5: 1.668,
    m2a: 7.228,
    m3b: 36.14,
    qlmv: 0.058,
    qlav: 0.13,
    formula: "(R454A, GWP¹ = 238)",
    description:
      "A mildly flammable (A2L) hydrofluoro-olefin (HFO) energy efficient² refrigerant with global warming potential (GWP¹) less than 250, offering superior cooling properties for replacement of R-404A in new equipment designs, including positive displacement, direct expansion low- and medium temperature commercial and industrial applications.",
  },
  {
    enabled: true,
    id: "XL41",
    title: "Opteon™ XL41",
    lfl: 0.303,
    m1x1_5: 1.818,
    m2a: 7.878,
    m3b: 39.39,
    qlmv: 0.064,
    qlav: 0.15,
    formula: "(R454B, GWP¹ = 467)",
    description:
      "A mildly flammable (A2L) hydrofluoro-olefin (HFO) energy efficient³ refrigerant with low global warming potential (GWP¹), offering the optimal balance of properties to replace R-410A in new equipment designs, including positive displacement, direct expansion air conditioning, heat pump and chiller applications.",
  },
  {
    enabled: false,
    id: "XL55",
    title: "Opteon™ XL55",
    lfl: 0.31,
    m1x1_5: 1.86,
    m2a: 8.06,
    m3b: 40.3,
    qlmv: 0.065,
    qlav: 0.15,
    formula: "(R452B, GWP¹ = 698)",
    description: "",
  },
  {
    enabled: false,
    id: "R32",
    title: "R32",
    lfl: 0.307,
    m1x1_5: 1.842,
    m2a: 7.982,
    m3b: 39.91,
    qlmv: 0.063,
    qlav: 0.15,
    formula: "",
    description: "",
  },
  {
    enabled: false,
    id: "R455A",
    title: "R455A",
    lfl: 0.431,
    m1x1_5: 2.586,
    m2a: 11.206,
    m3b: 56.03,
    qlmv: 0.092,
    qlav: 0.21,
    formula: "",
    description: "",
  },
  {
    enabled: false,
    id: "R290",
    title: "R290",
    lfl: 0.0375,
    m1x1_5: 4,
    m2a: 0,
    m3b: 0,
    qlmv: 0,
    qlav: 0,
    formula: "",
    description: "",
  },
  {
    enabled: false,
    id: "R152a",
    title: "R152a",
    lfl: 0.13,
    m1x1_5: 4,
    m2a: 0,
    m3b: 0,
    qlmv: 0,
    qlav: 0,
    formula: "",
    description: "",
  },
] as Fluid[];
